import swal from "sweetalert";

export const PrimaryColor = "#ff7c04";
export const SecondaryColor = "#34656D";
export const TertiaryColor = "#FF5733";
export const QuaternaryColor = "#50C878";
export const Color1 = "#28565D";
export const ColorRed = "#dc3545";
export const ColorBlue = "#0d6efd";
export const ColorSkyBlue = "#0dcaf0";
export const ColorYellow = "#ffc107";
export const ColorGray = "#DEDFDF";
export const mail = "info@gna.energy";

export const volumeBar = "#E0E0E0";
export const volumeBarLegend = "rgb(159, 159, 159)";

const baseUri = "https://datahub.gna.energy";

export function buildUrl(path: string) {
  return `${baseUri}/${path}`;
}

const ErrorAlert = ({
  title = "",
  message,
}: {
  title?: string;
  message: string;
}) => {
  swal({
    title: title,
    text: message,
  });
};
export async function buildHttpReq({
  endpoint,
  method = "GET",
  body = null,
  header = {},
  customUrl,
}: {
  endpoint?: string;
  method?: string;
  body?: any;
  header?: any;
  customUrl?: string;
}) {
  // convert body to form data
  const formData = new FormData();
  Object.keys(body).forEach((key) => formData.append(key, body[key]));
  const response = await fetch(
    endpoint != null ? buildUrl(endpoint) : customUrl != null ? customUrl : "",
    {
      method: method,
      headers: {
        ...header,
      },
      body: formData,
    }
  );
  return await response.json();
}

export const formatDMY = (date?: string | null): string =>
  date ? date.split("-").reverse().join("-") : "";

export const COLOR_CODES = {
  primary: "#f1935c",
  secondary: "#34656d",
  black: "#333333",
  aquamarine: "#A1C1FF",
  charcol: "#B8860B",
  mcp: "#232D51",
  tertiary: "#9f9f9f",
  stroke: "#e4e7ed",
  secondaryAccent: "#fbffff",
  accent: "#fff7f3",
  lightGrey: "#f1f1f1",
  white: "#ffffff",
  torqouise: "#edf3ff",
  iex: "#ff0000",
  hpx: "#000080",
  pixl: "#7C5500",
  purchaseBids: "#000080",
  sellBid: "#6e360f",
  priceBid: "#d2691e",
  mcv: "#DEDFDF",
  weightedMCP: "#366a36",
  dam: "#8cb742",
  rtm: "#d65627",
  hpdAm: "#215f92",
  gdam: "#00b24f",
  daily: "#2f4f4f",
  intraday: "#556b2f",
  weekly: "#4b0082",
  monthly: "#2e8b57",
  iexForecast: "#343C6A",
  dac: "#bc9e00",
  hpDaily: "#483d8b",
  hpIntraDay: "#2c3e50",
  hpDac: "#a0522d",
  hpMonthly: "#6b8e23",
  anydaySSC: "#700000",
  bilateral: "#9932cc",
  dailyPrice: "#5a6a6a",
  intradayPrice: "#6a7b4f",
  dacPrice: "#a66a44",
  weeklyPrice: "#6b469c",
  monthlyPrice: "#477a69",
  hpDailyPrice: "#5f5c82",
  hpIntradayPrice: "#475a6a",
  hpDacPrice: "#c78562",
  hpMonthlyPrice: "#87a34f",
  anydayContract: "#40566d",
  thermal: "#333536",
  largeHydro: "#1e90ff",
  hydro: "#ade0ee",
  solar: "#ffd565",
  wind: "#a1d978",
  fbsm: "#006400",
  gas: "#34b9b3",
  nuclear: "#e16900",
  bioPower: "#af6ab1",
  renewableEnergy: "#32cd32",
};

// COLOR_CODES List
export const COLOR_CODES_LIST = [
  "#f1935c", // primary
  "#34656d", // secondary
  "#333333", // charcol/black
  "#5d095d", // mcp
  "#9f9f9f", // tertiary
  "#d2691e", // priceBid
  "#366a36", // weightedMCP
  "#8cb742", // dam
  "#d65627", // rtm
  "#215f92", // hpdAm
  "#00b24f", // gdam
  "#2f4f4f", // daily
  "#556b2f", // intraday
  "#4b0082", // weekly
  "#2e8b57", // monthly
  "#343C6A", // iexForecast
  "#bc9e00", // dac
  "#700000", // anydaySSC
  "#9932cc", // bilateral
  "#6b469c", // weeklyPrice
  "#40566d", // anydayContract
  "#333536", // thermal
  "#1e90ff", // largeHydro
  "#006400", // fbsm
  "#34b9b3", // gas
  "#e16900", // nuclear
  // "#af6ab1", // bioPower
  "#32cd32", // renewableEnergy
];

export const isMobile: boolean = window.innerWidth < 768;
